<div class="content audit-page">
  <div class="container-fluid">
    <div class="audit-page-header">
      <div>
        <h1 class="dashboard-title">Audit Queue</h1>
        <p>Review and process patient verifications submitted for audit.</p>
      </div>
    </div>

    <p class="audit-domain-metrics-note">Summary KPIs cover both Dental and Medical. Use the Domain filter to narrow the queue.</p>
    <div class="audit-metrics-grid">
      <div class="audit-metric-card">
        <div class="audit-metric-icon metric-blue">
          <i class="fa-regular fa-file-lines"></i>
        </div>
        <div>
          <div class="audit-metric-label">Total Audits</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.totalAudits }}</div>
        </div>
      </div>

      <div class="audit-metric-card">
        <div class="audit-metric-icon metric-orange">
          <i class="fa-regular fa-clock"></i>
        </div>
        <div>
          <div class="audit-metric-label">Pending</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.pending }}</div>
        </div>
      </div>

      <div class="audit-metric-card">
        <div class="audit-metric-icon metric-purple">
          <i class="fa-solid fa-arrows-rotate"></i>
        </div>
        <div>
          <div class="audit-metric-label">In Audit</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.inAudit }}</div>
        </div>
      </div>

      <div class="audit-metric-card">
        <div class="audit-metric-icon metric-red">
          <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div>
          <div class="audit-metric-label">Changes Requested</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.changesRequested }}</div>
        </div>
      </div>

      <div class="audit-metric-card">
        <div class="audit-metric-icon metric-green">
          <i class="fa-regular fa-circle-check"></i>
        </div>
        <div>
          <div class="audit-metric-label">Quality Score</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.qualityScore }}</div>
        </div>
      </div>

      <!-- <div class="audit-metric-card">
        <div class="audit-metric-icon metric-indigo">
          <i class="fa-regular fa-hourglass-half"></i>
        </div>
        <div>
          <div class="audit-metric-label">Avg TAT</div>
          <div class="audit-metric-value">{{ metricsLoading ? '-' : metrics.averageTat }}</div>
        </div>
      </div> -->
    </div>

    <div class="audit-toolbar">
      <div class="audit-search">
        <i class="fa fa-search"></i>
        <input
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange($event)"
          type="text"
          maxlength="100"
          placeholder="Search patient name or patient reference...">
      </div>

      <div
        class="audit-assignment-toolbar"
        *ngIf="authService.hasRole('audit-edit')">

        <div class="audit-auditor-select-wrap">
          <i class="fa-regular fa-user audit-auditor-icon"></i>

          <select
            class="audit-auditor-select"
            [(ngModel)]="assignmentAuditor">

            <option value="">
              Select Auditor
            </option>

            <option
              *ngFor="let auditor of auditors"
              [value]="auditor.keycloakId">
              {{ auditor.fullName }}
            </option>

          </select>

          <i class="fa-solid fa-chevron-down audit-auditor-chevron"></i>
        </div>

        <button
          *ngIf="selectedAuditIds.length > 0"
          type="button"
          class="toolbar-btn toolbar-btn-primary audit-assignment-action"
          (click)="assignSelectedAudits()"
          [disabled]="assigning || !assignmentAuditor">

          <span
            *ngIf="assigning"
            class="spinner-border spinner-border-sm mr-1">
          </span>

          <i
            *ngIf="!assigning"
            class="fa-solid fa-user-check">
          </i>

          Assign {{ selectedAuditIds.length }}
        </button>

      </div>

      <div class="audit-filter-dropdown" #filterContainer>
        <button
          type="button"
          class="toolbar-btn toolbar-btn-light audit-filter-trigger"
          [class.active]="isFilterOpen"
          (click)="toggleFilterPanel(); $event.stopPropagation()">
          <i class="fa-solid fa-sliders"></i>
          <span>Filters</span>
          <span *ngIf="activeFilterCount > 0" class="filter-count">{{ activeFilterCount }}</span>
        </button>

        <div
          class="audit-filter-popover"
          [hidden]="!isFilterOpen"
          (click)="$event.stopPropagation()">

          <div class="audit-filter-popover-header">
            <div>
              <div class="audit-filter-title-row">
                <span class="audit-filter-title">Filters</span>
                <span *ngIf="activeFilterCount > 0" class="audit-filter-summary">
                  {{ activeFilterCount }} active
                </span>
              </div>
              <div class="audit-filter-subtitle">Combine filters and apply them together.</div>
            </div>

            <button type="button" class="audit-filter-close" (click)="closeFilterPanel()">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div class="audit-filter-popover-body">
            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Date Range</div>
              <div class="audit-filter-date-grid">
                <div class="audit-filter-field-popover">
                  <label>From</label>
                  <div class="audit-date-wrap">
                    <i class="fa-regular fa-calendar-days"></i>
                    <input [(ngModel)]="draftFromDate" type="date">
                  </div>
                </div>

                <div class="audit-filter-field-popover">
                  <label>To</label>
                  <div class="audit-date-wrap">
                    <i class="fa-regular fa-calendar-days"></i>
                    <input [(ngModel)]="draftToDate" type="date">
                  </div>
                </div>
              </div>
            </div>

            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Status</div>
              <div class="audit-filter-choice-grid status-grid">
                <button
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftStatus === ''"
                  (click)="draftStatus = ''">
                  Any
                </button>
                <button
                  *ngFor="let item of statuses"
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftStatus === item.value"
                  (click)="draftStatus = item.value">
                  {{ item.label }}
                </button>
              </div>
            </div>

            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Priority</div>
              <div class="audit-filter-choice-grid four-grid">
                <button
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftPriority === ''"
                  (click)="draftPriority = ''">
                  Any
                </button>
                <button
                  *ngFor="let priority of priorities"
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftPriority === priority"
                  (click)="draftPriority = priority">
                  {{ priority }}
                </button>
              </div>
            </div>

            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Benefit Domain</div>
              <div class="audit-filter-choice-grid status-grid" role="group" aria-label="Benefit domain">
                <button type="button" class="audit-filter-choice" [class.active]="draftBenefitDomain === ''"
                        (click)="draftBenefitDomain = ''">All Domains</button>
                <button type="button" class="audit-filter-choice" [class.active]="draftBenefitDomain === 'DENTAL'"
                        (click)="draftBenefitDomain = 'DENTAL'">Dental</button>
                <button type="button" class="audit-filter-choice" [class.active]="draftBenefitDomain === 'MEDICAL'"
                        (click)="draftBenefitDomain = 'MEDICAL'">Medical</button>
              </div>
            </div>

            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Form Type</div>
              <div class="audit-filter-choice-grid four-grid">
                <button
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftFormType === ''"
                  (click)="draftFormType = ''">
                  Any
                </button>
                <button
                  *ngFor="let formType of formTypes"
                  type="button"
                  class="audit-filter-choice"
                  [class.active]="draftFormType === formType"
                  (click)="draftFormType = formType">
                  {{ formType }}
                </button>
              </div>
            </div>

            <div class="audit-filter-section">
              <div class="audit-filter-section-label">Assigned Auditor</div>
              <mat-form-field appearance="outline" class="audit-filter-auditor-select">
                <mat-select [(ngModel)]="draftAuditor" placeholder="All Auditors">
                  <mat-option value="">All Auditors</mat-option>
                  <mat-option *ngFor="let auditor of auditors" [value]="auditor.keycloakId">
                    {{ auditor.fullName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="audit-filter-popover-footer">
            <button
              type="button"
              class="toolbar-btn toolbar-btn-light"
              (click)="resetFilterPanel($event)">
              <i class="fa-solid fa-rotate-left"></i>
              Reset
            </button>

            <button
              type="button"
              class="toolbar-btn toolbar-btn-primary"
              (click)="applyFilterPanel()">
              <i class="fa-solid fa-check"></i>
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="audit-table-card table-panel">
      <div class="audit-loading" *ngIf="loading">
        <span class="spinner-border spinner-border-sm mr-2"></span>
        Loading audit queue...
      </div>

      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th *ngIf="authService.hasRole('audit-edit')" class="audit-select-column">
                <input
                  type="checkbox"
                  [checked]="allSelectableSelected"
                  (change)="toggleSelectAll()"
                  aria-label="Select all assignable audits on this page">
              </th>
              <th>SR.NO</th>
              <th>Patient</th>
              <th>Patient Ref.</th>
              <th>Insurance</th>
              <th>Domain</th>
              <th>Form Type</th>
              <th>Submitted By</th>
              <th>Submitted On</th>
              <th>Auditor</th>
              <th>Priority</th>
              <th>Audit Status</th>
              <th>Score</th>
              <th>ACTION</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let row of rows; let i = index; trackBy: trackById">
              <td *ngIf="authService.hasRole('audit-edit')" class="audit-select-column">
                <input
                  type="checkbox"
                  [checked]="isRowSelected(row.id)"
                  [disabled]="!isRowSelectable(row)"
                  (change)="toggleRowSelection(row)"
                  aria-label="Select audit">
              </td>
              <td>{{ (page * size) + i + 1 }}</td>
              <td>
                <div class="audit-patient-name">{{ row.patientName }}</div>
                <div class="audit-patient-id">Patient ID: {{ row.patientId }}</div>
              </td>
              <td>{{ row.patientReference || '-' }}</td>
              <td>{{ row.insuranceSelection }}</td>
              <td><span class="audit-domain-pill" [class.medical]="row.benefitDomain === 'MEDICAL'">{{ row.benefitDomain === 'MEDICAL' ? 'Medical' : 'Dental' }}</span></td>
              <td>{{ row.formType }}</td>
              <td>{{ row.submittedBy }}</td>
              <td>{{ row.submittedAt | date:'MM/dd/yyyy hh:mm a':'UTC' }}</td>
              <td>{{ row.auditor }}</td>
              <td>
                <span class="audit-pill" [ngClass]="getPriorityClass(row.priority)">
                  {{ row.priority }}
                </span>
              </td>
              <td>
                <span class="audit-pill" [ngClass]="getStatusClass(row.status)">
                  {{ getStatusLabel(row.status) }}
                </span>
              </td>
              <td>{{ row.score === null ? '-' : row.score }}</td>

              <td>
                <button
                  type="button"
                  class="btn btn-sm btn-primary audit-open-btn"
                  (click)="openAudit(row)">
                  <i class="fa-regular fa-folder-open mr-1"></i>
                  {{ getActionLabel(row.status) }}
                </button>
              </td>
            </tr>

            <tr *ngIf="!loading && rows.length === 0">
              <td
                [attr.colspan]="authService.hasRole('audit-edit') ? 14 : 13"
                class="table-empty">
                No audit records found for the selected filters.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="rows.length !== 0" class="audit-pagination-wrap">
        <mat-paginator
          [length]="totalRecords"
          [pageIndex]="page"
          [pageSize]="size"
          [pageSizeOptions]="[5, 10, 25, 100]"
          aria-label="Select audit queue page"
          showFirstLastButtons
          color="warn"
          (page)="pageChange($event)">
        </mat-paginator>

        <mat-form-field appearance="outline" class="page-selector">
          <mat-label>Go to Page</mat-label>
          <mat-select [ngModel]="page" (selectionChange)="jumpToPage($event)">
            <mat-option *ngFor="let pageNumber of totalPagesArray" [value]="pageNumber - 1">
              {{ pageNumber }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
